"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateOptions = exports.UrlRecord = exports.TxIDRecord = exports.SubscribeOptions = exports.SubmitOptions = exports.Submission = exports.SignatureSetRecord = exports.ServiceAddress = exports.RecordRange = exports.ReceiptOptions = exports.Receipt = exports.RangeOptions = exports.PublicKeySearchQuery = exports.PublicKeyHashSearchQuery = exports.PendingQuery = exports.NodeInfoOptions = exports.NodeInfo = exports.NetworkStatusOptions = exports.NetworkStatus = exports.MinorBlockRecord = exports.MessageRecord = exports.MessageHashSearchQuery = exports.MajorBlockRecord = exports.LastBlock = exports.KeyRecord = exports.IndexEntryRecord = exports.GlobalsEvent = exports.FindServiceResult = exports.FindServiceOptions = exports.FaucetOptions = exports.ErrorRecord = exports.ErrorEvent = exports.DirectoryQuery = exports.DelegateSearchQuery = exports.DefaultQuery = exports.DataQuery = exports.ConsensusStatusOptions = exports.ConsensusStatus = exports.ConsensusPeerInfo = exports.ChainRecord = exports.ChainQuery = exports.ChainEntryRecord = exports.BlockQuery = exports.BlockEvent = exports.AnchorSearchQuery = exports.AccountRecord = void 0;
const _1 = require(".");
const txid_1 = require("../address/txid");
const url_1 = require("../address/url");
const buffer_1 = require("../common/buffer");
const protocol = __importStar(require("../core"));
const encoding_1 = require("../encoding");
const errors2 = __importStar(require("../errors"));
const merkle = __importStar(require("../merkle"));
const messaging = __importStar(require("../messaging"));
const core = __importStar(require("../network"));
const enums_gen_1 = require("./enums_gen");
const p2p = __importStar(require("./p2p"));
class AccountRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.Account;
        this.account =
            args.account == undefined ? undefined : protocol.Account.fromObject(args.account);
        this.directory =
            args.directory == undefined
                ? undefined
                : args.directory instanceof (RecordRange)
                    ? args.directory
                    : new RecordRange(args.directory);
        this.pending =
            args.pending == undefined
                ? undefined
                : args.pending instanceof (RecordRange)
                    ? args.pending
                    : new RecordRange(args.pending);
        this.receipt =
            args.receipt == undefined
                ? undefined
                : args.receipt instanceof Receipt
                    ? args.receipt
                    : new Receipt(args.receipt);
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new AccountRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "account",
            account: this.account && this.account.asObject(),
            directory: this.directory && this.directory.asObject(),
            pending: this.pending && this.pending.asObject(),
            receipt: this.receipt && this.receipt.asObject(),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], AccountRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], AccountRecord.prototype, "account", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], AccountRecord.prototype, "directory", void 0);
__decorate([
    encoding_1.encodeAs.field(4).reference
], AccountRecord.prototype, "pending", void 0);
__decorate([
    encoding_1.encodeAs.field(5).reference
], AccountRecord.prototype, "receipt", void 0);
__decorate([
    encoding_1.encodeAs.field(6).time
], AccountRecord.prototype, "lastBlockTime", void 0);
exports.AccountRecord = AccountRecord;
class AnchorSearchQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.AnchorSearch;
        this.anchor =
            args.anchor == undefined
                ? undefined
                : args.anchor instanceof Uint8Array
                    ? args.anchor
                    : buffer_1.Buffer.from(args.anchor, "hex");
        this.includeReceipt =
            args.includeReceipt == undefined
                ? undefined
                : args.includeReceipt instanceof ReceiptOptions
                    ? args.includeReceipt
                    : new ReceiptOptions(args.includeReceipt);
    }
    copy() {
        return new AnchorSearchQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "anchorSearch",
            anchor: this.anchor && this.anchor && buffer_1.Buffer.from(this.anchor).toString("hex"),
            includeReceipt: this.includeReceipt && this.includeReceipt.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], AnchorSearchQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], AnchorSearchQuery.prototype, "anchor", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], AnchorSearchQuery.prototype, "includeReceipt", void 0);
exports.AnchorSearchQuery = AnchorSearchQuery;
class BlockEvent {
    constructor(args) {
        this.eventType = enums_gen_1.EventType.Block;
        this.partition = args.partition == undefined ? undefined : args.partition;
        this.index = args.index == undefined ? undefined : args.index;
        this.time =
            args.time == undefined
                ? undefined
                : args.time instanceof Date
                    ? args.time
                    : new Date(args.time);
        this.major = args.major == undefined ? undefined : args.major;
        this.entries =
            args.entries == undefined
                ? undefined
                : args.entries.map((v) => v == undefined
                    ? undefined
                    : v instanceof (ChainEntryRecord)
                        ? v
                        : new ChainEntryRecord(v));
    }
    copy() {
        return new BlockEvent(this.asObject());
    }
    asObject() {
        return {
            eventType: "block",
            partition: this.partition && this.partition,
            index: this.index && this.index,
            time: this.time && this.time,
            major: this.major && this.major,
            entries: this.entries && this.entries?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.EventType)
], BlockEvent.prototype, "eventType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], BlockEvent.prototype, "partition", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], BlockEvent.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(4).time
], BlockEvent.prototype, "time", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], BlockEvent.prototype, "major", void 0);
__decorate([
    encoding_1.encodeAs.field(6).repeatable.reference
], BlockEvent.prototype, "entries", void 0);
exports.BlockEvent = BlockEvent;
class BlockQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.Block;
        this.minor = args.minor == undefined ? undefined : args.minor;
        this.major = args.major == undefined ? undefined : args.major;
        this.minorRange =
            args.minorRange == undefined
                ? undefined
                : args.minorRange instanceof RangeOptions
                    ? args.minorRange
                    : new RangeOptions(args.minorRange);
        this.majorRange =
            args.majorRange == undefined
                ? undefined
                : args.majorRange instanceof RangeOptions
                    ? args.majorRange
                    : new RangeOptions(args.majorRange);
        this.entryRange =
            args.entryRange == undefined
                ? undefined
                : args.entryRange instanceof RangeOptions
                    ? args.entryRange
                    : new RangeOptions(args.entryRange);
        this.omitEmpty = args.omitEmpty == undefined ? undefined : args.omitEmpty;
    }
    copy() {
        return new BlockQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "block",
            minor: this.minor && this.minor,
            major: this.major && this.major,
            minorRange: this.minorRange && this.minorRange.asObject(),
            majorRange: this.majorRange && this.majorRange.asObject(),
            entryRange: this.entryRange && this.entryRange.asObject(),
            omitEmpty: this.omitEmpty && this.omitEmpty,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], BlockQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], BlockQuery.prototype, "minor", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], BlockQuery.prototype, "major", void 0);
__decorate([
    encoding_1.encodeAs.field(4).reference
], BlockQuery.prototype, "minorRange", void 0);
__decorate([
    encoding_1.encodeAs.field(5).reference
], BlockQuery.prototype, "majorRange", void 0);
__decorate([
    encoding_1.encodeAs.field(6).reference
], BlockQuery.prototype, "entryRange", void 0);
__decorate([
    encoding_1.encodeAs.field(7).bool
], BlockQuery.prototype, "omitEmpty", void 0);
exports.BlockQuery = BlockQuery;
class ChainEntryRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.ChainEntry;
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
        this.name = args.name == undefined ? undefined : args.name;
        this.type = args.type == undefined ? undefined : merkle.ChainType.fromObject(args.type);
        this.index = args.index == undefined ? undefined : args.index;
        this.entry =
            args.entry == undefined
                ? undefined
                : args.entry instanceof Uint8Array
                    ? args.entry
                    : buffer_1.Buffer.from(args.entry, "hex");
        this.value = args.value == undefined ? undefined : _1.Record.fromObject(args.value);
        this.receipt =
            args.receipt == undefined
                ? undefined
                : args.receipt instanceof Receipt
                    ? args.receipt
                    : new Receipt(args.receipt);
        this.state =
            args.state == undefined
                ? undefined
                : args.state.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new ChainEntryRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "chainEntry",
            account: this.account && this.account.toString(),
            name: this.name && this.name,
            type: this.type && merkle.ChainType.getName(this.type),
            index: this.index && this.index,
            entry: this.entry && this.entry && buffer_1.Buffer.from(this.entry).toString("hex"),
            value: this.value && this.value.asObject(),
            receipt: this.receipt && this.receipt.asObject(),
            state: this.state &&
                this.state?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], ChainEntryRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], ChainEntryRecord.prototype, "account", void 0);
__decorate([
    encoding_1.encodeAs.field(3).string
], ChainEntryRecord.prototype, "name", void 0);
__decorate([
    encoding_1.encodeAs.field(4).enum
], ChainEntryRecord.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(5).keepEmpty.uint
], ChainEntryRecord.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(6).hash
], ChainEntryRecord.prototype, "entry", void 0);
__decorate([
    encoding_1.encodeAs.field(7).union
], ChainEntryRecord.prototype, "value", void 0);
__decorate([
    encoding_1.encodeAs.field(8).reference
], ChainEntryRecord.prototype, "receipt", void 0);
__decorate([
    encoding_1.encodeAs.field(9).repeatable.bytes
], ChainEntryRecord.prototype, "state", void 0);
__decorate([
    encoding_1.encodeAs.field(10).time
], ChainEntryRecord.prototype, "lastBlockTime", void 0);
exports.ChainEntryRecord = ChainEntryRecord;
class ChainQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.Chain;
        this.name = args.name == undefined ? undefined : args.name;
        this.index = args.index == undefined ? undefined : args.index;
        this.entry =
            args.entry == undefined
                ? undefined
                : args.entry instanceof Uint8Array
                    ? args.entry
                    : buffer_1.Buffer.from(args.entry, "hex");
        this.range =
            args.range == undefined
                ? undefined
                : args.range instanceof RangeOptions
                    ? args.range
                    : new RangeOptions(args.range);
        this.includeReceipt =
            args.includeReceipt == undefined
                ? undefined
                : args.includeReceipt instanceof ReceiptOptions
                    ? args.includeReceipt
                    : new ReceiptOptions(args.includeReceipt);
    }
    copy() {
        return new ChainQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "chain",
            name: this.name && this.name,
            index: this.index && this.index,
            entry: this.entry && this.entry && buffer_1.Buffer.from(this.entry).toString("hex"),
            range: this.range && this.range.asObject(),
            includeReceipt: this.includeReceipt && this.includeReceipt.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], ChainQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], ChainQuery.prototype, "name", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], ChainQuery.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bytes
], ChainQuery.prototype, "entry", void 0);
__decorate([
    encoding_1.encodeAs.field(5).reference
], ChainQuery.prototype, "range", void 0);
__decorate([
    encoding_1.encodeAs.field(6).reference
], ChainQuery.prototype, "includeReceipt", void 0);
exports.ChainQuery = ChainQuery;
class ChainRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.Chain;
        this.name = args.name == undefined ? undefined : args.name;
        this.type = args.type == undefined ? undefined : merkle.ChainType.fromObject(args.type);
        this.count = args.count == undefined ? undefined : args.count;
        this.state =
            args.state == undefined
                ? undefined
                : args.state.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new ChainRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "chain",
            name: this.name && this.name,
            type: this.type && merkle.ChainType.getName(this.type),
            count: this.count && this.count,
            state: this.state &&
                this.state?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], ChainRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], ChainRecord.prototype, "name", void 0);
__decorate([
    encoding_1.encodeAs.field(3).enum
], ChainRecord.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], ChainRecord.prototype, "count", void 0);
__decorate([
    encoding_1.encodeAs.field(5).repeatable.bytes
], ChainRecord.prototype, "state", void 0);
__decorate([
    encoding_1.encodeAs.field(6).time
], ChainRecord.prototype, "lastBlockTime", void 0);
exports.ChainRecord = ChainRecord;
class ConsensusPeerInfo {
    constructor(args) {
        this.nodeID = args.nodeID == undefined ? undefined : args.nodeID;
        this.host = args.host == undefined ? undefined : args.host;
        this.port = args.port == undefined ? undefined : args.port;
    }
    copy() {
        return new ConsensusPeerInfo(this.asObject());
    }
    asObject() {
        return {
            nodeID: this.nodeID && this.nodeID,
            host: this.host && this.host,
            port: this.port && this.port,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], ConsensusPeerInfo.prototype, "nodeID", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], ConsensusPeerInfo.prototype, "host", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], ConsensusPeerInfo.prototype, "port", void 0);
exports.ConsensusPeerInfo = ConsensusPeerInfo;
class ConsensusStatus {
    constructor(args) {
        this.ok = args.ok == undefined ? undefined : args.ok;
        this.lastBlock =
            args.lastBlock == undefined
                ? undefined
                : args.lastBlock instanceof LastBlock
                    ? args.lastBlock
                    : new LastBlock(args.lastBlock);
        this.version = args.version == undefined ? undefined : args.version;
        this.commit = args.commit == undefined ? undefined : args.commit;
        this.nodeKeyHash =
            args.nodeKeyHash == undefined
                ? undefined
                : args.nodeKeyHash instanceof Uint8Array
                    ? args.nodeKeyHash
                    : buffer_1.Buffer.from(args.nodeKeyHash, "hex");
        this.validatorKeyHash =
            args.validatorKeyHash == undefined
                ? undefined
                : args.validatorKeyHash instanceof Uint8Array
                    ? args.validatorKeyHash
                    : buffer_1.Buffer.from(args.validatorKeyHash, "hex");
        this.partitionID = args.partitionID == undefined ? undefined : args.partitionID;
        this.partitionType =
            args.partitionType == undefined
                ? undefined
                : protocol.PartitionType.fromObject(args.partitionType);
        this.peers =
            args.peers == undefined
                ? undefined
                : args.peers.map((v) => v == undefined
                    ? undefined
                    : v instanceof ConsensusPeerInfo
                        ? v
                        : new ConsensusPeerInfo(v));
    }
    copy() {
        return new ConsensusStatus(this.asObject());
    }
    asObject() {
        return {
            ok: this.ok && this.ok,
            lastBlock: this.lastBlock && this.lastBlock.asObject(),
            version: this.version && this.version,
            commit: this.commit && this.commit,
            nodeKeyHash: this.nodeKeyHash && this.nodeKeyHash && buffer_1.Buffer.from(this.nodeKeyHash).toString("hex"),
            validatorKeyHash: this.validatorKeyHash &&
                this.validatorKeyHash &&
                buffer_1.Buffer.from(this.validatorKeyHash).toString("hex"),
            partitionID: this.partitionID && this.partitionID,
            partitionType: this.partitionType && protocol.PartitionType.getName(this.partitionType),
            peers: this.peers && this.peers?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bool
], ConsensusStatus.prototype, "ok", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], ConsensusStatus.prototype, "lastBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(3).string
], ConsensusStatus.prototype, "version", void 0);
__decorate([
    encoding_1.encodeAs.field(4).string
], ConsensusStatus.prototype, "commit", void 0);
__decorate([
    encoding_1.encodeAs.field(5).hash
], ConsensusStatus.prototype, "nodeKeyHash", void 0);
__decorate([
    encoding_1.encodeAs.field(6).hash
], ConsensusStatus.prototype, "validatorKeyHash", void 0);
__decorate([
    encoding_1.encodeAs.field(7).string
], ConsensusStatus.prototype, "partitionID", void 0);
__decorate([
    encoding_1.encodeAs.field(8).enum
], ConsensusStatus.prototype, "partitionType", void 0);
__decorate([
    encoding_1.encodeAs.field(9).repeatable.reference
], ConsensusStatus.prototype, "peers", void 0);
exports.ConsensusStatus = ConsensusStatus;
class ConsensusStatusOptions {
    constructor(args) {
        this.nodeID = args.nodeID == undefined ? undefined : args.nodeID;
        this.partition = args.partition == undefined ? undefined : args.partition;
        this.includePeers = args.includePeers == undefined ? undefined : args.includePeers;
        this.includeAccumulate =
            args.includeAccumulate == undefined ? undefined : args.includeAccumulate;
    }
    copy() {
        return new ConsensusStatusOptions(this.asObject());
    }
    asObject() {
        return {
            nodeID: this.nodeID && this.nodeID,
            partition: this.partition && this.partition,
            includePeers: this.includePeers && this.includePeers,
            includeAccumulate: this.includeAccumulate && this.includeAccumulate,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], ConsensusStatusOptions.prototype, "nodeID", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], ConsensusStatusOptions.prototype, "partition", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bool
], ConsensusStatusOptions.prototype, "includePeers", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bool
], ConsensusStatusOptions.prototype, "includeAccumulate", void 0);
exports.ConsensusStatusOptions = ConsensusStatusOptions;
class DataQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.Data;
        this.index = args.index == undefined ? undefined : args.index;
        this.entry =
            args.entry == undefined
                ? undefined
                : args.entry instanceof Uint8Array
                    ? args.entry
                    : buffer_1.Buffer.from(args.entry, "hex");
        this.range =
            args.range == undefined
                ? undefined
                : args.range instanceof RangeOptions
                    ? args.range
                    : new RangeOptions(args.range);
    }
    copy() {
        return new DataQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "data",
            index: this.index && this.index,
            entry: this.entry && this.entry && buffer_1.Buffer.from(this.entry).toString("hex"),
            range: this.range && this.range.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], DataQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], DataQuery.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], DataQuery.prototype, "entry", void 0);
__decorate([
    encoding_1.encodeAs.field(4).reference
], DataQuery.prototype, "range", void 0);
exports.DataQuery = DataQuery;
class DefaultQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.Default;
        this.includeReceipt =
            args.includeReceipt == undefined
                ? undefined
                : args.includeReceipt instanceof ReceiptOptions
                    ? args.includeReceipt
                    : new ReceiptOptions(args.includeReceipt);
    }
    copy() {
        return new DefaultQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "default",
            includeReceipt: this.includeReceipt && this.includeReceipt.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], DefaultQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], DefaultQuery.prototype, "includeReceipt", void 0);
exports.DefaultQuery = DefaultQuery;
class DelegateSearchQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.DelegateSearch;
        this.delegate = args.delegate == undefined ? undefined : url_1.AccumulateURL.parse(args.delegate);
    }
    copy() {
        return new DelegateSearchQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "delegateSearch",
            delegate: this.delegate && this.delegate.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], DelegateSearchQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], DelegateSearchQuery.prototype, "delegate", void 0);
exports.DelegateSearchQuery = DelegateSearchQuery;
class DirectoryQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.Directory;
        this.range =
            args.range == undefined
                ? undefined
                : args.range instanceof RangeOptions
                    ? args.range
                    : new RangeOptions(args.range);
    }
    copy() {
        return new DirectoryQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "directory",
            range: this.range && this.range.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], DirectoryQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], DirectoryQuery.prototype, "range", void 0);
exports.DirectoryQuery = DirectoryQuery;
class ErrorEvent {
    constructor(args) {
        this.eventType = enums_gen_1.EventType.Error;
        this.err =
            args.err == undefined
                ? undefined
                : args.err instanceof errors2.Error
                    ? args.err
                    : new errors2.Error(args.err);
    }
    copy() {
        return new ErrorEvent(this.asObject());
    }
    asObject() {
        return {
            eventType: "error",
            err: this.err && this.err.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.EventType)
], ErrorEvent.prototype, "eventType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], ErrorEvent.prototype, "err", void 0);
exports.ErrorEvent = ErrorEvent;
class ErrorRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.Error;
        this.value =
            args.value == undefined
                ? undefined
                : args.value instanceof errors2.Error
                    ? args.value
                    : new errors2.Error(args.value);
    }
    copy() {
        return new ErrorRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "error",
            value: this.value && this.value.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], ErrorRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], ErrorRecord.prototype, "value", void 0);
exports.ErrorRecord = ErrorRecord;
class FaucetOptions {
    constructor(args) {
        this.token = args.token == undefined ? undefined : url_1.AccumulateURL.parse(args.token);
    }
    copy() {
        return new FaucetOptions(this.asObject());
    }
    asObject() {
        return {
            token: this.token && this.token.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], FaucetOptions.prototype, "token", void 0);
exports.FaucetOptions = FaucetOptions;
class FindServiceOptions {
    constructor(args) {
        this.network = args.network == undefined ? undefined : args.network;
        this.service =
            args.service == undefined
                ? undefined
                : args.service instanceof ServiceAddress
                    ? args.service
                    : new ServiceAddress(args.service);
        this.known = args.known == undefined ? undefined : args.known;
        this.timeout = args.timeout == undefined ? undefined : args.timeout;
    }
    copy() {
        return new FindServiceOptions(this.asObject());
    }
    asObject() {
        return {
            network: this.network && this.network,
            service: this.service && this.service.asObject(),
            known: this.known && this.known,
            timeout: this.timeout && this.timeout,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], FindServiceOptions.prototype, "network", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], FindServiceOptions.prototype, "service", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bool
], FindServiceOptions.prototype, "known", void 0);
__decorate([
    encoding_1.encodeAs.field(4).duration
], FindServiceOptions.prototype, "timeout", void 0);
exports.FindServiceOptions = FindServiceOptions;
class FindServiceResult {
    constructor(args) {
        this.peerID = args.peerID == undefined ? undefined : p2p.PeerID.fromObject(args.peerID);
        this.status = args.status == undefined ? undefined : enums_gen_1.KnownPeerStatus.fromObject(args.status);
        this.addresses =
            args.addresses == undefined
                ? undefined
                : args.addresses.map((v) => (v == undefined ? undefined : p2p.Multiaddr.fromObject(v)));
    }
    copy() {
        return new FindServiceResult(this.asObject());
    }
    asObject() {
        return {
            peerID: this.peerID && this.peerID.asObject(),
            status: this.status && enums_gen_1.KnownPeerStatus.getName(this.status),
            addresses: this.addresses && this.addresses?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).union
], FindServiceResult.prototype, "peerID", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], FindServiceResult.prototype, "status", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.union
], FindServiceResult.prototype, "addresses", void 0);
exports.FindServiceResult = FindServiceResult;
class GlobalsEvent {
    constructor(args) {
        this.eventType = enums_gen_1.EventType.Globals;
        this.old =
            args.old == undefined
                ? undefined
                : args.old instanceof core.GlobalValues
                    ? args.old
                    : new core.GlobalValues(args.old);
        this.new =
            args.new == undefined
                ? undefined
                : args.new instanceof core.GlobalValues
                    ? args.new
                    : new core.GlobalValues(args.new);
    }
    copy() {
        return new GlobalsEvent(this.asObject());
    }
    asObject() {
        return {
            eventType: "globals",
            old: this.old && this.old.asObject(),
            new: this.new && this.new.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.EventType)
], GlobalsEvent.prototype, "eventType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], GlobalsEvent.prototype, "old", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], GlobalsEvent.prototype, "new", void 0);
exports.GlobalsEvent = GlobalsEvent;
class IndexEntryRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.IndexEntry;
        this.value =
            args.value == undefined
                ? undefined
                : args.value instanceof protocol.IndexEntry
                    ? args.value
                    : new protocol.IndexEntry(args.value);
    }
    copy() {
        return new IndexEntryRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "indexEntry",
            value: this.value && this.value.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], IndexEntryRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], IndexEntryRecord.prototype, "value", void 0);
exports.IndexEntryRecord = IndexEntryRecord;
class KeyRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.Key;
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.version = args.version == undefined ? undefined : args.version;
        this.index = args.index == undefined ? undefined : args.index;
        this.entry =
            args.entry == undefined
                ? undefined
                : args.entry instanceof protocol.KeySpec
                    ? args.entry
                    : new protocol.KeySpec(args.entry);
    }
    copy() {
        return new KeyRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "key",
            authority: this.authority && this.authority.toString(),
            signer: this.signer && this.signer.toString(),
            version: this.version && this.version,
            index: this.index && this.index,
            entry: this.entry && this.entry.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], KeyRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], KeyRecord.prototype, "authority", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], KeyRecord.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], KeyRecord.prototype, "version", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], KeyRecord.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(6).reference
], KeyRecord.prototype, "entry", void 0);
exports.KeyRecord = KeyRecord;
class LastBlock {
    constructor(args) {
        this.height = args.height == undefined ? undefined : args.height;
        this.time =
            args.time == undefined
                ? undefined
                : args.time instanceof Date
                    ? args.time
                    : new Date(args.time);
        this.chainRoot =
            args.chainRoot == undefined
                ? undefined
                : args.chainRoot instanceof Uint8Array
                    ? args.chainRoot
                    : buffer_1.Buffer.from(args.chainRoot, "hex");
        this.stateRoot =
            args.stateRoot == undefined
                ? undefined
                : args.stateRoot instanceof Uint8Array
                    ? args.stateRoot
                    : buffer_1.Buffer.from(args.stateRoot, "hex");
        this.directoryAnchorHeight =
            args.directoryAnchorHeight == undefined ? undefined : args.directoryAnchorHeight;
    }
    copy() {
        return new LastBlock(this.asObject());
    }
    asObject() {
        return {
            height: this.height && this.height,
            time: this.time && this.time,
            chainRoot: this.chainRoot && this.chainRoot && buffer_1.Buffer.from(this.chainRoot).toString("hex"),
            stateRoot: this.stateRoot && this.stateRoot && buffer_1.Buffer.from(this.stateRoot).toString("hex"),
            directoryAnchorHeight: this.directoryAnchorHeight && this.directoryAnchorHeight,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).int
], LastBlock.prototype, "height", void 0);
__decorate([
    encoding_1.encodeAs.field(2).time
], LastBlock.prototype, "time", void 0);
__decorate([
    encoding_1.encodeAs.field(3).hash
], LastBlock.prototype, "chainRoot", void 0);
__decorate([
    encoding_1.encodeAs.field(4).hash
], LastBlock.prototype, "stateRoot", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], LastBlock.prototype, "directoryAnchorHeight", void 0);
exports.LastBlock = LastBlock;
class MajorBlockRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.MajorBlock;
        this.index = args.index == undefined ? undefined : args.index;
        this.time =
            args.time == undefined
                ? undefined
                : args.time instanceof Date
                    ? args.time
                    : new Date(args.time);
        this.minorBlocks =
            args.minorBlocks == undefined
                ? undefined
                : args.minorBlocks instanceof (RecordRange)
                    ? args.minorBlocks
                    : new RecordRange(args.minorBlocks);
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new MajorBlockRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "majorBlock",
            index: this.index && this.index,
            time: this.time && this.time,
            minorBlocks: this.minorBlocks && this.minorBlocks.asObject(),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], MajorBlockRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], MajorBlockRecord.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(3).time
], MajorBlockRecord.prototype, "time", void 0);
__decorate([
    encoding_1.encodeAs.field(4).reference
], MajorBlockRecord.prototype, "minorBlocks", void 0);
__decorate([
    encoding_1.encodeAs.field(5).time
], MajorBlockRecord.prototype, "lastBlockTime", void 0);
exports.MajorBlockRecord = MajorBlockRecord;
class MessageHashSearchQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.MessageHashSearch;
        this.hash =
            args.hash == undefined
                ? undefined
                : args.hash instanceof Uint8Array
                    ? args.hash
                    : buffer_1.Buffer.from(args.hash, "hex");
    }
    copy() {
        return new MessageHashSearchQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "messageHashSearch",
            hash: this.hash && this.hash && buffer_1.Buffer.from(this.hash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], MessageHashSearchQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).hash
], MessageHashSearchQuery.prototype, "hash", void 0);
exports.MessageHashSearchQuery = MessageHashSearchQuery;
class MessageRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.Message;
        this.id = args.id == undefined ? undefined : txid_1.AccumulateTxID.parse(args.id);
        this.message =
            args.message == undefined ? undefined : messaging.Message.fromObject(args.message);
        this.status = args.status == undefined ? undefined : errors2.Status.fromObject(args.status);
        this.error =
            args.error == undefined
                ? undefined
                : args.error instanceof errors2.Error
                    ? args.error
                    : new errors2.Error(args.error);
        this.result =
            args.result == undefined ? undefined : protocol.TransactionResult.fromObject(args.result);
        this.received = args.received == undefined ? undefined : args.received;
        this.produced =
            args.produced == undefined
                ? undefined
                : args.produced instanceof (RecordRange)
                    ? args.produced
                    : new RecordRange(args.produced);
        this.cause =
            args.cause == undefined
                ? undefined
                : args.cause instanceof (RecordRange)
                    ? args.cause
                    : new RecordRange(args.cause);
        this.signatures =
            args.signatures == undefined
                ? undefined
                : args.signatures instanceof (RecordRange)
                    ? args.signatures
                    : new RecordRange(args.signatures);
        this.historical = args.historical == undefined ? undefined : args.historical;
        this.sequence =
            args.sequence == undefined
                ? undefined
                : args.sequence instanceof messaging.SequencedMessage
                    ? args.sequence
                    : new messaging.SequencedMessage(args.sequence);
        this.sourceReceipt =
            args.sourceReceipt == undefined
                ? undefined
                : args.sourceReceipt instanceof merkle.Receipt
                    ? args.sourceReceipt
                    : new merkle.Receipt(args.sourceReceipt);
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new MessageRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "message",
            id: this.id && this.id.toString(),
            message: this.message && this.message.asObject(),
            status: this.status && errors2.Status.getName(this.status),
            error: this.error && this.error.asObject(),
            result: this.result && this.result.asObject(),
            received: this.received && this.received,
            produced: this.produced && this.produced.asObject(),
            cause: this.cause && this.cause.asObject(),
            signatures: this.signatures && this.signatures.asObject(),
            historical: this.historical && this.historical,
            sequence: this.sequence && this.sequence.asObject(),
            sourceReceipt: this.sourceReceipt && this.sourceReceipt.asObject(),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], MessageRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).txid
], MessageRecord.prototype, "id", void 0);
__decorate([
    encoding_1.encodeAs.field(3).union
], MessageRecord.prototype, "message", void 0);
__decorate([
    encoding_1.encodeAs.field(4).enum
], MessageRecord.prototype, "status", void 0);
__decorate([
    encoding_1.encodeAs.field(5).reference
], MessageRecord.prototype, "error", void 0);
__decorate([
    encoding_1.encodeAs.field(6).union
], MessageRecord.prototype, "result", void 0);
__decorate([
    encoding_1.encodeAs.field(7).uint
], MessageRecord.prototype, "received", void 0);
__decorate([
    encoding_1.encodeAs.field(8).reference
], MessageRecord.prototype, "produced", void 0);
__decorate([
    encoding_1.encodeAs.field(9).reference
], MessageRecord.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(10).reference
], MessageRecord.prototype, "signatures", void 0);
__decorate([
    encoding_1.encodeAs.field(11).bool
], MessageRecord.prototype, "historical", void 0);
__decorate([
    encoding_1.encodeAs.field(12).reference
], MessageRecord.prototype, "sequence", void 0);
__decorate([
    encoding_1.encodeAs.field(13).reference
], MessageRecord.prototype, "sourceReceipt", void 0);
__decorate([
    encoding_1.encodeAs.field(14).time
], MessageRecord.prototype, "lastBlockTime", void 0);
exports.MessageRecord = MessageRecord;
class MinorBlockRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.MinorBlock;
        this.index = args.index == undefined ? undefined : args.index;
        this.time =
            args.time == undefined
                ? undefined
                : args.time instanceof Date
                    ? args.time
                    : new Date(args.time);
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.entries =
            args.entries == undefined
                ? undefined
                : args.entries instanceof (RecordRange)
                    ? args.entries
                    : new RecordRange(args.entries);
        this.anchored =
            args.anchored == undefined
                ? undefined
                : args.anchored instanceof (RecordRange)
                    ? args.anchored
                    : new RecordRange(args.anchored);
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new MinorBlockRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "minorBlock",
            index: this.index && this.index,
            time: this.time && this.time,
            source: this.source && this.source.toString(),
            entries: this.entries && this.entries.asObject(),
            anchored: this.anchored && this.anchored.asObject(),
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], MinorBlockRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], MinorBlockRecord.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(3).time
], MinorBlockRecord.prototype, "time", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], MinorBlockRecord.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(5).reference
], MinorBlockRecord.prototype, "entries", void 0);
__decorate([
    encoding_1.encodeAs.field(6).reference
], MinorBlockRecord.prototype, "anchored", void 0);
__decorate([
    encoding_1.encodeAs.field(7).time
], MinorBlockRecord.prototype, "lastBlockTime", void 0);
exports.MinorBlockRecord = MinorBlockRecord;
class NetworkStatus {
    constructor(args) {
        this.oracle =
            args.oracle == undefined
                ? undefined
                : args.oracle instanceof protocol.AcmeOracle
                    ? args.oracle
                    : new protocol.AcmeOracle(args.oracle);
        this.globals =
            args.globals == undefined
                ? undefined
                : args.globals instanceof protocol.NetworkGlobals
                    ? args.globals
                    : new protocol.NetworkGlobals(args.globals);
        this.network =
            args.network == undefined
                ? undefined
                : args.network instanceof protocol.NetworkDefinition
                    ? args.network
                    : new protocol.NetworkDefinition(args.network);
        this.routing =
            args.routing == undefined
                ? undefined
                : args.routing instanceof protocol.RoutingTable
                    ? args.routing
                    : new protocol.RoutingTable(args.routing);
        this.executorVersion =
            args.executorVersion == undefined
                ? undefined
                : protocol.ExecutorVersion.fromObject(args.executorVersion);
        this.directoryHeight = args.directoryHeight == undefined ? undefined : args.directoryHeight;
        this.majorBlockHeight = args.majorBlockHeight == undefined ? undefined : args.majorBlockHeight;
        this.bvnExecutorVersions =
            args.bvnExecutorVersions == undefined
                ? undefined
                : args.bvnExecutorVersions.map((v) => v == undefined
                    ? undefined
                    : v instanceof protocol.PartitionExecutorVersion
                        ? v
                        : new protocol.PartitionExecutorVersion(v));
    }
    copy() {
        return new NetworkStatus(this.asObject());
    }
    asObject() {
        return {
            oracle: this.oracle && this.oracle.asObject(),
            globals: this.globals && this.globals.asObject(),
            network: this.network && this.network.asObject(),
            routing: this.routing && this.routing.asObject(),
            executorVersion: this.executorVersion && protocol.ExecutorVersion.getName(this.executorVersion),
            directoryHeight: this.directoryHeight && this.directoryHeight,
            majorBlockHeight: this.majorBlockHeight && this.majorBlockHeight,
            bvnExecutorVersions: this.bvnExecutorVersions &&
                this.bvnExecutorVersions?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).reference
], NetworkStatus.prototype, "oracle", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], NetworkStatus.prototype, "globals", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], NetworkStatus.prototype, "network", void 0);
__decorate([
    encoding_1.encodeAs.field(4).reference
], NetworkStatus.prototype, "routing", void 0);
__decorate([
    encoding_1.encodeAs.field(5).enum
], NetworkStatus.prototype, "executorVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], NetworkStatus.prototype, "directoryHeight", void 0);
__decorate([
    encoding_1.encodeAs.field(7).uint
], NetworkStatus.prototype, "majorBlockHeight", void 0);
__decorate([
    encoding_1.encodeAs.field(8).repeatable.reference
], NetworkStatus.prototype, "bvnExecutorVersions", void 0);
exports.NetworkStatus = NetworkStatus;
class NetworkStatusOptions {
    constructor(args) {
        this.partition = args.partition == undefined ? undefined : args.partition;
    }
    copy() {
        return new NetworkStatusOptions(this.asObject());
    }
    asObject() {
        return {
            partition: this.partition && this.partition,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], NetworkStatusOptions.prototype, "partition", void 0);
exports.NetworkStatusOptions = NetworkStatusOptions;
class NodeInfo {
    constructor(args) {
        this.peerID = args.peerID == undefined ? undefined : p2p.PeerID.fromObject(args.peerID);
        this.network = args.network == undefined ? undefined : args.network;
        this.services =
            args.services == undefined
                ? undefined
                : args.services.map((v) => v == undefined ? undefined : v instanceof ServiceAddress ? v : new ServiceAddress(v));
        this.version = args.version == undefined ? undefined : args.version;
        this.commit = args.commit == undefined ? undefined : args.commit;
    }
    copy() {
        return new NodeInfo(this.asObject());
    }
    asObject() {
        return {
            peerID: this.peerID && this.peerID.asObject(),
            network: this.network && this.network,
            services: this.services && this.services?.map((v) => (v == undefined ? undefined : v.asObject())),
            version: this.version && this.version,
            commit: this.commit && this.commit,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).union
], NodeInfo.prototype, "peerID", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], NodeInfo.prototype, "network", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.reference
], NodeInfo.prototype, "services", void 0);
__decorate([
    encoding_1.encodeAs.field(4).string
], NodeInfo.prototype, "version", void 0);
__decorate([
    encoding_1.encodeAs.field(5).string
], NodeInfo.prototype, "commit", void 0);
exports.NodeInfo = NodeInfo;
class NodeInfoOptions {
    constructor(args) {
        this.peerID = args.peerID == undefined ? undefined : p2p.PeerID.fromObject(args.peerID);
    }
    copy() {
        return new NodeInfoOptions(this.asObject());
    }
    asObject() {
        return {
            peerID: this.peerID && this.peerID.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).union
], NodeInfoOptions.prototype, "peerID", void 0);
exports.NodeInfoOptions = NodeInfoOptions;
class PendingQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.Pending;
        this.range =
            args.range == undefined
                ? undefined
                : args.range instanceof RangeOptions
                    ? args.range
                    : new RangeOptions(args.range);
    }
    copy() {
        return new PendingQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "pending",
            range: this.range && this.range.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], PendingQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], PendingQuery.prototype, "range", void 0);
exports.PendingQuery = PendingQuery;
class PublicKeyHashSearchQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.PublicKeyHashSearch;
        this.publicKeyHash =
            args.publicKeyHash == undefined
                ? undefined
                : args.publicKeyHash instanceof Uint8Array
                    ? args.publicKeyHash
                    : buffer_1.Buffer.from(args.publicKeyHash, "hex");
    }
    copy() {
        return new PublicKeyHashSearchQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "publicKeyHashSearch",
            publicKeyHash: this.publicKeyHash && this.publicKeyHash && buffer_1.Buffer.from(this.publicKeyHash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], PublicKeyHashSearchQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], PublicKeyHashSearchQuery.prototype, "publicKeyHash", void 0);
exports.PublicKeyHashSearchQuery = PublicKeyHashSearchQuery;
class PublicKeySearchQuery {
    constructor(args) {
        this.queryType = enums_gen_1.QueryType.PublicKeySearch;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.type = args.type == undefined ? undefined : protocol.SignatureType.fromObject(args.type);
    }
    copy() {
        return new PublicKeySearchQuery(this.asObject());
    }
    asObject() {
        return {
            queryType: "publicKeySearch",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            type: this.type && protocol.SignatureType.getName(this.type),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.QueryType)
], PublicKeySearchQuery.prototype, "queryType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], PublicKeySearchQuery.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).enum
], PublicKeySearchQuery.prototype, "type", void 0);
exports.PublicKeySearchQuery = PublicKeySearchQuery;
class RangeOptions {
    constructor(args) {
        this.start = args.start == undefined ? undefined : args.start;
        this.count = args.count == undefined ? undefined : args.count;
        this.expand = args.expand == undefined ? undefined : args.expand;
        this.fromEnd = args.fromEnd == undefined ? undefined : args.fromEnd;
    }
    copy() {
        return new RangeOptions(this.asObject());
    }
    asObject() {
        return {
            start: this.start && this.start,
            count: this.count && this.count,
            expand: this.expand && this.expand,
            fromEnd: this.fromEnd && this.fromEnd,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], RangeOptions.prototype, "start", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], RangeOptions.prototype, "count", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bool
], RangeOptions.prototype, "expand", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bool
], RangeOptions.prototype, "fromEnd", void 0);
exports.RangeOptions = RangeOptions;
class Receipt {
    constructor(args) {
        this.start =
            args.start == undefined
                ? undefined
                : args.start instanceof Uint8Array
                    ? args.start
                    : buffer_1.Buffer.from(args.start, "hex");
        this.startIndex = args.startIndex == undefined ? undefined : args.startIndex;
        this.end =
            args.end == undefined
                ? undefined
                : args.end instanceof Uint8Array
                    ? args.end
                    : buffer_1.Buffer.from(args.end, "hex");
        this.endIndex = args.endIndex == undefined ? undefined : args.endIndex;
        this.anchor =
            args.anchor == undefined
                ? undefined
                : args.anchor instanceof Uint8Array
                    ? args.anchor
                    : buffer_1.Buffer.from(args.anchor, "hex");
        this.entries =
            args.entries == undefined
                ? undefined
                : args.entries.map((v) => v == undefined
                    ? undefined
                    : v instanceof merkle.ReceiptEntry
                        ? v
                        : new merkle.ReceiptEntry(v));
        this.localBlock = args.localBlock == undefined ? undefined : args.localBlock;
        this.localBlockTime =
            args.localBlockTime == undefined
                ? undefined
                : args.localBlockTime instanceof Date
                    ? args.localBlockTime
                    : new Date(args.localBlockTime);
        this.majorBlock = args.majorBlock == undefined ? undefined : args.majorBlock;
    }
    copy() {
        return new Receipt(this.asObject());
    }
    asObject() {
        return {
            start: this.start && this.start && buffer_1.Buffer.from(this.start).toString("hex"),
            startIndex: this.startIndex && this.startIndex,
            end: this.end && this.end && buffer_1.Buffer.from(this.end).toString("hex"),
            endIndex: this.endIndex && this.endIndex,
            anchor: this.anchor && this.anchor && buffer_1.Buffer.from(this.anchor).toString("hex"),
            entries: this.entries && this.entries?.map((v) => (v == undefined ? undefined : v.asObject())),
            localBlock: this.localBlock && this.localBlock,
            localBlockTime: this.localBlockTime && this.localBlockTime,
            majorBlock: this.majorBlock && this.majorBlock,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1, 1).bytes
], Receipt.prototype, "start", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 2).int
], Receipt.prototype, "startIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 3).bytes
], Receipt.prototype, "end", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 4).int
], Receipt.prototype, "endIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 5).bytes
], Receipt.prototype, "anchor", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 6).repeatable.reference
], Receipt.prototype, "entries", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], Receipt.prototype, "localBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(3).time
], Receipt.prototype, "localBlockTime", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], Receipt.prototype, "majorBlock", void 0);
exports.Receipt = Receipt;
class ReceiptOptions {
    constructor(args) {
        this.forAny = args.forAny == undefined ? undefined : args.forAny;
        this.forHeight = args.forHeight == undefined ? undefined : args.forHeight;
    }
    copy() {
        return new ReceiptOptions(this.asObject());
    }
    asObject() {
        return {
            forAny: this.forAny && this.forAny,
            forHeight: this.forHeight && this.forHeight,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bool
], ReceiptOptions.prototype, "forAny", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], ReceiptOptions.prototype, "forHeight", void 0);
exports.ReceiptOptions = ReceiptOptions;
class RecordRange {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.Range;
        this.records =
            args.records == undefined
                ? undefined
                : args.records.map((v) => (v == undefined ? undefined : _1.Record.fromObject(v)));
        this.start = args.start == undefined ? undefined : args.start;
        this.total = args.total == undefined ? undefined : args.total;
        this.lastBlockTime =
            args.lastBlockTime == undefined
                ? undefined
                : args.lastBlockTime instanceof Date
                    ? args.lastBlockTime
                    : new Date(args.lastBlockTime);
    }
    copy() {
        return new RecordRange(this.asObject());
    }
    asObject() {
        return {
            recordType: "range",
            records: this.records && this.records?.map((v) => (v == undefined ? undefined : v.asObject())),
            start: this.start && this.start,
            total: this.total && this.total,
            lastBlockTime: this.lastBlockTime && this.lastBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], RecordRange.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.union
], RecordRange.prototype, "records", void 0);
__decorate([
    encoding_1.encodeAs.field(3).keepEmpty.uint
], RecordRange.prototype, "start", void 0);
__decorate([
    encoding_1.encodeAs.field(4).keepEmpty.uint
], RecordRange.prototype, "total", void 0);
__decorate([
    encoding_1.encodeAs.field(5).time
], RecordRange.prototype, "lastBlockTime", void 0);
exports.RecordRange = RecordRange;
class ServiceAddress {
    constructor(args) {
        this.type = args.type == undefined ? undefined : args.type;
        this.argument = args.argument == undefined ? undefined : args.argument;
    }
    copy() {
        return new ServiceAddress(this.asObject());
    }
    asObject() {
        return {
            type: this.type && this.type,
            argument: this.argument && this.argument,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], ServiceAddress.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], ServiceAddress.prototype, "argument", void 0);
exports.ServiceAddress = ServiceAddress;
class SignatureSetRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.SignatureSet;
        this.account =
            args.account == undefined ? undefined : protocol.Account.fromObject(args.account);
        this.signatures =
            args.signatures == undefined
                ? undefined
                : args.signatures instanceof (RecordRange)
                    ? args.signatures
                    : new RecordRange(args.signatures);
    }
    copy() {
        return new SignatureSetRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "signatureSet",
            account: this.account && this.account.asObject(),
            signatures: this.signatures && this.signatures.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], SignatureSetRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], SignatureSetRecord.prototype, "account", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], SignatureSetRecord.prototype, "signatures", void 0);
exports.SignatureSetRecord = SignatureSetRecord;
class Submission {
    constructor(args) {
        this.status =
            args.status == undefined
                ? undefined
                : args.status instanceof protocol.TransactionStatus
                    ? args.status
                    : new protocol.TransactionStatus(args.status);
        this.success = args.success == undefined ? undefined : args.success;
        this.message = args.message == undefined ? undefined : args.message;
    }
    copy() {
        return new Submission(this.asObject());
    }
    asObject() {
        return {
            status: this.status && this.status.asObject(),
            success: this.success && this.success,
            message: this.message && this.message,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).reference
], Submission.prototype, "status", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bool
], Submission.prototype, "success", void 0);
__decorate([
    encoding_1.encodeAs.field(3).string
], Submission.prototype, "message", void 0);
exports.Submission = Submission;
class SubmitOptions {
    constructor(args) {
        this.verify = args.verify == undefined ? undefined : args.verify;
        this.wait = args.wait == undefined ? undefined : args.wait;
    }
    copy() {
        return new SubmitOptions(this.asObject());
    }
    asObject() {
        return {
            verify: this.verify && this.verify,
            wait: this.wait && this.wait,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bool
], SubmitOptions.prototype, "verify", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bool
], SubmitOptions.prototype, "wait", void 0);
exports.SubmitOptions = SubmitOptions;
class SubscribeOptions {
    constructor(args) {
        this.partition = args.partition == undefined ? undefined : args.partition;
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
    }
    copy() {
        return new SubscribeOptions(this.asObject());
    }
    asObject() {
        return {
            partition: this.partition && this.partition,
            account: this.account && this.account.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], SubscribeOptions.prototype, "partition", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], SubscribeOptions.prototype, "account", void 0);
exports.SubscribeOptions = SubscribeOptions;
class TxIDRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.TxID;
        this.value = args.value == undefined ? undefined : txid_1.AccumulateTxID.parse(args.value);
    }
    copy() {
        return new TxIDRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "txID",
            value: this.value && this.value.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], TxIDRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).txid
], TxIDRecord.prototype, "value", void 0);
exports.TxIDRecord = TxIDRecord;
class UrlRecord {
    constructor(args) {
        this.recordType = enums_gen_1.RecordType.Url;
        this.value = args.value == undefined ? undefined : url_1.AccumulateURL.parse(args.value);
    }
    copy() {
        return new UrlRecord(this.asObject());
    }
    asObject() {
        return {
            recordType: "url",
            value: this.value && this.value.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(enums_gen_1.RecordType)
], UrlRecord.prototype, "recordType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], UrlRecord.prototype, "value", void 0);
exports.UrlRecord = UrlRecord;
class ValidateOptions {
    constructor(args) {
        this.full = args.full == undefined ? undefined : args.full;
    }
    copy() {
        return new ValidateOptions(this.asObject());
    }
    asObject() {
        return {
            full: this.full && this.full,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bool
], ValidateOptions.prototype, "full", void 0);
exports.ValidateOptions = ValidateOptions;
//# sourceMappingURL=types_gen.js.map